import styled from '@emotion/styled';
import React from 'react';

const Svg = styled.svg`
    width: 18px;
    height: 18px;
`;

export const Info = () => {
    return (
        <Svg viewBox={'0 0 24 24'} aria-label={'information icon'}>
            <path
                fill={'currentColor'}
                d={
                    'M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-.696-3.534c.63 0 ' +
                    '1.332-.288 2.196-1.458l.911-1.22a.334.334 0 0 0-.074-.472.38.38 0 0 0-.505.06l-1.475 1.679a.' +
                    '241.241 0 0 1-.279.061.211.211 0 0 1-.12-.244l1.858-7.446a.499.499 0 0 0-.575-.613l-3.35.613' +
                    'a.35.35 0 0 0-.276.258l-.086.334a.25.25 0 0 0 .243.312h1.73l-1.476 5.922c-.054.234-.144.63-.' +
                    '144.918 0 .666.396 1.296 1.422 1.296zm1.83-10.536c.702 0 1.242-.414 1.386-1.044.036-.144.054' +
                    '-.306.054-.414 0-.504-.396-.972-1.134-.972-.702 0-1.242.414-1.386 1.044a1.868 1.868 0 0 0-.0' +
                    '54.414c0 .504.396.972 1.134.972z'
                }
            />
        </Svg>
    );
};
